const map = {
	"./ar/achievements.json": 5331,
	"./ar/achievementsData.json": 7163,
	"./ar/ascendancy.json": 4894,
	"./ar/auth.json": 1901,
	"./ar/common.json": 8634,
	"./ar/guides.json": 3630,
	"./ar/heroes.json": 3939,
	"./ar/home.json": 164,
	"./ar/leaderboard.json": 294,
	"./ar/legal.json": 7612,
	"./ar/productInfo.json": 8570,
	"./ar/profile.json": 3096,
	"./ar/resetPassword.json": 1755,
	"./ar/simulator.json": 8391,
	"./de/achievements.json": 75,
	"./de/achievementsData.json": 4883,
	"./de/ascendancy.json": 2678,
	"./de/auth.json": 2245,
	"./de/common.json": 9378,
	"./de/guides.json": 5046,
	"./de/heroes.json": 2027,
	"./de/home.json": 316,
	"./de/leaderboard.json": 8814,
	"./de/legal.json": 4564,
	"./de/productInfo.json": 9186,
	"./de/profile.json": 8688,
	"./de/resetPassword.json": 7155,
	"./de/simulator.json": 1999,
	"./en/achievements.json": 675,
	"./en/achievementsData.json": 1099,
	"./en/ascendancy.json": 1022,
	"./en/auth.json": 5021,
	"./en/common.json": 9802,
	"./en/guides.json": 4574,
	"./en/heroes.json": 3747,
	"./en/home.json": 4820,
	"./en/leaderboard.json": 6070,
	"./en/legal.json": 5596,
	"./en/productInfo.json": 1818,
	"./en/profile.json": 1432,
	"./en/resetPassword.json": 2411,
	"./en/simulator.json": 7495,
	"./es/achievements.json": 7210,
	"./es/achievementsData.json": 8186,
	"./es/ascendancy.json": 1795,
	"./es/auth.json": 3552,
	"./es/common.json": 7067,
	"./es/guides.json": 651,
	"./es/heroes.json": 934,
	"./es/home.json": 8265,
	"./es/leaderboard.json": 977,
	"./es/legal.json": 8675,
	"./es/productInfo.json": 4661,
	"./es/profile.json": 8423,
	"./es/resetPassword.json": 4008,
	"./es/simulator.json": 8380,
	"./fr/achievements.json": 6850,
	"./fr/achievementsData.json": 8354,
	"./fr/ascendancy.json": 9819,
	"./fr/auth.json": 9368,
	"./fr/common.json": 227,
	"./fr/guides.json": 5203,
	"./fr/heroes.json": 9358,
	"./fr/home.json": 2801,
	"./fr/leaderboard.json": 3257,
	"./fr/legal.json": 6779,
	"./fr/productInfo.json": 9517,
	"./fr/profile.json": 1599,
	"./fr/resetPassword.json": 6128,
	"./fr/simulator.json": 3556,
	"./hi/achievements.json": 5507,
	"./hi/achievementsData.json": 2299,
	"./hi/ascendancy.json": 254,
	"./hi/auth.json": 9885,
	"./hi/common.json": 1738,
	"./hi/guides.json": 5438,
	"./hi/heroes.json": 5635,
	"./hi/home.json": 7604,
	"./hi/leaderboard.json": 3689,
	"./hi/legal.json": 7756,
	"./hi/productInfo.json": 5306,
	"./hi/profile.json": 4136,
	"./hi/resetPassword.json": 3387,
	"./hi/simulator.json": 2407,
	"./id/achievements.json": 141,
	"./id/achievementsData.json": 5245,
	"./id/ascendancy.json": 3308,
	"./id/auth.json": 2679,
	"./id/common.json": 7076,
	"./id/guides.json": 568,
	"./id/heroes.json": 3305,
	"./id/home.json": 914,
	"./id/leaderboard.json": 6156,
	"./id/legal.json": 9350,
	"./id/productInfo.json": 6656,
	"./id/profile.json": 2594,
	"./id/resetPassword.json": 1253,
	"./id/simulator.json": 5849,
	"./it/achievements.json": 7677,
	"./it/achievementsData.json": 109,
	"./it/ascendancy.json": 6412,
	"./it/auth.json": 7415,
	"./it/common.json": 1140,
	"./it/guides.json": 7000,
	"./it/heroes.json": 521,
	"./it/home.json": 8226,
	"./it/leaderboard.json": 540,
	"./it/legal.json": 182,
	"./it/productInfo.json": 1376,
	"./it/profile.json": 6978,
	"./it/resetPassword.json": 789,
	"./it/simulator.json": 6153,
	"./ja/achievements.json": 9273,
	"./ja/achievementsData.json": 7881,
	"./ja/ascendancy.json": 0,
	"./ja/auth.json": 9147,
	"./ja/common.json": 9520,
	"./ja/guides.json": 7324,
	"./ja/heroes.json": 8021,
	"./ja/home.json": 7166,
	"./ja/leaderboard.json": 2024,
	"./ja/legal.json": 3842,
	"./ja/productInfo.json": 9652,
	"./ja/profile.json": 4126,
	"./ja/resetPassword.json": 5601,
	"./ja/simulator.json": 4637,
	"./ko/achievements.json": 8828,
	"./ko/achievementsData.json": 9124,
	"./ko/ascendancy.json": 5945,
	"./ko/auth.json": 8866,
	"./ko/common.json": 2605,
	"./ko/guides.json": 637,
	"./ko/heroes.json": 8812,
	"./ko/home.json": 8463,
	"./ko/leaderboard.json": 3703,
	"./ko/legal.json": 3829,
	"./ko/productInfo.json": 4387,
	"./ko/profile.json": 5473,
	"./ko/resetPassword.json": 7410,
	"./ko/simulator.json": 1830,
	"./pt-br/achievements.json": 1645,
	"./pt-br/achievementsData.json": 3165,
	"./pt-br/ascendancy.json": 1708,
	"./pt-br/auth.json": 711,
	"./pt-br/common.json": 6836,
	"./pt-br/guides.json": 8392,
	"./pt-br/heroes.json": 921,
	"./pt-br/home.json": 1938,
	"./pt-br/leaderboard.json": 2524,
	"./pt-br/legal.json": 2774,
	"./pt-br/productInfo.json": 6048,
	"./pt-br/profile.json": 2866,
	"./pt-br/resetPassword.json": 9765,
	"./pt-br/simulator.json": 9161,
	"./ru/achievements.json": 5837,
	"./ru/achievementsData.json": 8253,
	"./ru/ascendancy.json": 4476,
	"./ru/auth.json": 1783,
	"./ru/common.json": 1444,
	"./ru/guides.json": 8187,
	"./ru/heroes.json": 8921,
	"./ru/home.json": 9394,
	"./ru/leaderboard.json": 7068,
	"./ru/legal.json": 2486,
	"./ru/productInfo.json": 7872,
	"./ru/profile.json": 1394,
	"./ru/resetPassword.json": 8309,
	"./ru/simulator.json": 6857,
	"./ur/achievements.json": 8279,
	"./ur/achievementsData.json": 31,
	"./ur/ascendancy.json": 906,
	"./ur/auth.json": 5273,
	"./ur/common.json": 286,
	"./ur/guides.json": 1322,
	"./ur/heroes.json": 7143,
	"./ur/home.json": 8,
	"./ur/leaderboard.json": 6602,
	"./ur/legal.json": 7920,
	"./ur/productInfo.json": 8070,
	"./ur/profile.json": 3772,
	"./ur/resetPassword.json": 655,
	"./ur/simulator.json": 4771,
	"./zh-cn/achievements.json": 640,
	"./zh-cn/achievementsData.json": 8552,
	"./zh-cn/ascendancy.json": 885,
	"./zh-cn/auth.json": 8878,
	"./zh-cn/common.json": 5249,
	"./zh-cn/guides.json": 5929,
	"./zh-cn/heroes.json": 4672,
	"./zh-cn/home.json": 4003,
	"./zh-cn/leaderboard.json": 3003,
	"./zh-cn/legal.json": 5545,
	"./zh-cn/productInfo.json": 2767,
	"./zh-cn/profile.json": 8517,
	"./zh-cn/resetPassword.json": 6198,
	"./zh-cn/simulator.json": 9906
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3901;